export function size(parameters) {
  return {
    size: parameters[0]
  };
}
